import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let ShortTextDesign = class ShortTextDesign extends Vue {
    render(h) {
        return h('a-input', { props: {
                disabled: true,
                placeholder: "请输入"
            } });
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], ShortTextDesign.prototype, "control", void 0);
ShortTextDesign = tslib_1.__decorate([
    Component({ name: 'ShortTextDesign' })
], ShortTextDesign);
export default ShortTextDesign;
